import React, { ReactNode } from "react";
import { createPortal } from "react-dom";
import ClockModeIcon from "../ClockModeIcon";

interface ClockSettingsModalProps {
  show: boolean;
  setShow: (show: boolean) => void;
  header?: ReactNode;
  children?: ReactNode;
  onClose?: () => void; // 可选的关闭回调
}

const ClockSettingsModal: React.FC<ClockSettingsModalProps> = ({
  show,
  setShow,
  header,
  children,
  onClose,
}) => {
  if (!show) return null;

  const handleClose = () => {
    onClose?.(); // 调用关闭回调
    setShow(false);
  };

  return createPortal(
    <>
      <div
        className="clock-settings-overlay clock-no-select"
        onClick={handleClose}
      >
        <div
          className="clock-settings-modal"
          onClick={(e) => e.stopPropagation()}
        >
          <header>
            {header}
            <div className="spacer"></div>
            <button
              className="close-button cursor-pointer active:opacity-50 transition duration-150"
              onClick={handleClose}
            >
              <ClockModeIcon type="close" size={24} />
            </button>
          </header>
          <div className="clock-settings-modal-content">{children}</div>
        </div>
      </div>
    </>,
    document.body
  );
};

export default ClockSettingsModal;